import { CNPJMask } from "@/components/mask/CNPJMask";
import { TextField } from "@mui/material";

export function ModuleForm({ values, setValues }: any) {

  const handleCNPJChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const maskedValue = e.target.value;

    const digits = maskedValue.replace(/\D/g, "");

    setValues({
      ...values,
      cnpj_formated: maskedValue,
      cnpj: digits,
    });
  };

  const isInvalid =
    values.cnpj &&
    values.cnpj.replace(/\D/g, "").length < 14;

  return (
    <>
      <TextField
        label="Nome"
        value={values.name || ""}
        onChange={(e) =>
          setValues({ ...values, name: e.target.value })
        }
        fullWidth
      />

      <TextField
        label="CNPJ"
        placeholder="00.000.000/0000-00"
        value={values.cnpj_formated || ""}
        onChange={handleCNPJChange}
        error={isInvalid}
        helperText={isInvalid ? "CNPJ deve ter 14 números" : ""}
        fullWidth
        slotProps={{
          input: {
            inputComponent: CNPJMask as any,
          },
        }}
      />

      <TextField
        label="Razão Social"
        value={values.social_reason || ""}
        onChange={(e) =>
          setValues({ ...values, social_reason: e.target.value })
        }
        fullWidth
      />

      <TextField
        label="Código ERP"
        value={values.erp_code || ""}
        onChange={(e) =>
          setValues({ ...values, erp_code: e.target.value })
        }
        fullWidth
      />
    </>
  );
}